import React from 'react'
import PropTypes from 'prop-types'

import S from '../Loading.styled'

const Title = ({ className }) => {
  return <S.Title className={className}></S.Title>
}

Title.propTypes = {
  className: PropTypes.string,
}

export default Title
